<div class="auth-container">
  <div class="welcome-column">
    <h3 class="welcome-title">Welcome to Biboapp!</h3>
    <p class="welcome-message">A video sharing platform</p>
  </div>
  <ng-content></ng-content>
</div>
